import { render, staticRenderFns } from "./ImageViewerValue.vue?vue&type=template&id=042bf0b4&lang=pug&"
import script from "./ImageViewerValue.vue?vue&type=script&lang=ts&"
export * from "./ImageViewerValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports